import { Modal, Button } from "antd";
import { deleteNewsApi } from "api/broadcast";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { INews } from "models/broadcast";
import { useState } from "react";

interface IProp {
  open: boolean;
  news: INews;
  handleClose: () => void;
}

export default function DeleteModal({ open, news, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadNewses } = useDataLoadingContext();

  const handleDelete = async () => {
    setLoading(true);
    const { data, error } = await deleteNewsApi(news.id);
    if (data) {
      showSuccess("News deleted successfully");
      loadNewses();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to delete {news.title}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete} loading={loading} type="primary" danger>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}

